import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { LanguageService } from 'app/modules/common/services/language-service';
import _ from 'lodash';
import moment, { Moment } from 'moment';
import { CompanySideBarTreeViewService } from '../../services/company-side-bar-tree-view.service';
import { DashboardChartsService } from '../../services/dashboard-charts.service';
import { DashboardTablesService } from '../../services/dashboard-tables.service';


@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent implements OnInit {
    @Input() companyId: any
    // date picker
    datePickerControl: UntypedFormControl = new UntypedFormControl();

    selectedYear: number;
    selectedMonth: string;  // month is in Spanish and it only contains first three letters

    // until tree view is implemented company ID is hard coded
    public selectedCompanyId: number;


    constructor(
        private languageService: LanguageService,
        public chartsService: DashboardChartsService,
        public tablesService: DashboardTablesService,
        private _companySideBarTreeViewService: CompanySideBarTreeViewService
    ) { }

    ngOnInit(): void {
        this.selectedCompanyId = this.companyId

        // on startup, selected date is yesterday
        const selectedDate = moment().subtract({ days: 1 });

        this.datePickerControl = new UntypedFormControl(selectedDate);
        this.updateDateValues(selectedDate);

        // load data from API
        this.feedDataIntoServices(this.selectedCompanyId, selectedDate);

    }



    /**
     * Handle date inputs
     */
    dateInputHandler = () => {
        // update date values
        const selectedDate = this.datePickerControl.value as Moment;
        this.updateDateValues(selectedDate);

        // load data from API
        this.feedDataIntoServices(this.selectedCompanyId, selectedDate);
    };


    /**
     * Update selected year, month variables
     * @param date Date
     */
    private updateDateValues = (date: Moment) => {
        // update date variables
        this.selectedYear = date.year();
        this.selectedMonth = this.languageService.getMonthInSpanish(date.month()).substr(0, 3);
    };


    /**
     * Feed company ID and date into tables and charts service
     */
    private feedDataIntoServices = (empressaId: number, date: Moment) => {

        // feed data into tables service
        this.tablesService.feedData(empressaId, date);

        // feed data to chart service
        this.chartsService.feedData(empressaId, date);

    };

}